var ASSET_URL;
if (typeof __webpack_require__ !== 'undefined') {
    ASSET_URL = window.env.ASSET_URL;
}
else {
    // eslint-disable-next-line security/detect-non-literal-require
    ASSET_URL = require("".concat(__dirname, "/../../lib/version")).getVersionedAssetURL();
}
export var assetUrl = function (path) {
    if (ASSET_URL) {
        return "".concat(ASSET_URL).concat(path.replace('/docs', ''));
    }
    return path;
};
